(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NOWPaymentsMPApiJS", [], factory);
	else if(typeof exports === 'object')
		exports["NOWPaymentsMPApiJS"] = factory();
	else
		root["NOWPaymentsMPApiJS"] = factory();
})(this, function() {
return 